export default {
  error: {
    searchPlaceholder: '操作人/请求IP/方法描述',
    reqIp: '客户端IP',
    operator: '操作人',
    module: '模块名称',
    functionDesc: '方法描述',
    dateRange: '操作时间',
    type: '错误类型',
    function: '方法名',
    message: '错误描述',
    reqParams: '传入参数',
    adddate: '操作时间',
    title: '信息'
  },
  operation: {
    searchPlaceholder: '客户端IP/操作接口url',
    module: '接口名称',
    url: '操作接口url',
    inputValue: '请求参数',
    returnValue: '返回参数',
    executeSql: 'SQL日志',
    ip: '客户端IP',
    addbyName: '操作人员',
    timeConsume: '本次操作耗时(ms)',
    title: '参数信息'
  },
  jobError: {
    searchPlaceholder: '任务名/任务组名/任务描述查询',
    successSign: '是否成功',
    errorReason: '错误原因',
    dateTimeRange: '操作时间',
    jobName: '任务名',
    jobGroup: '任务组名',
    jobClass: '执行类入口',
    startTime: '开始时间',
    endTime: '结束时间',
    title: '信息',
    reqJson: '传入参数',
    retry: '重试',
    confirmInfo: '是否重试'
  }
}
